var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPakistanFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.58203,
    width: 23,
    height: 16.1429,
    rx: 3.5,
    fill: "white",
    stroke: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3814_67792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 25,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.58203,
    width: 23,
    height: 16.1429,
    rx: 3.5,
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3814_67792)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.08203,
    width: 24,
    height: 17.1429,
    fill: "#0A632F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 21.2249H7.35714V4.08203H0.5V21.2249Z",
    fill: "#0A632F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7887 13.2968C20.6787 14.3688 20.2218 15.3989 19.4142 16.2065C17.4892 18.1315 14.3005 18.0639 12.2921 16.0555C10.2837 14.0471 10.2161 10.8584 12.1411 8.93337C12.9487 8.12576 13.9787 7.66886 15.0507 7.55886C14.7131 7.75785 14.3934 8.0034 14.1017 8.29519C12.3516 10.0452 12.2651 12.796 13.9083 14.4393C15.5516 16.0825 18.3023 15.9959 20.0524 14.2459C20.3442 13.9541 20.5897 13.6345 20.7887 13.2968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5791 11.0288L18.3064 12.656L17.5441 11.1927L15.9122 11.4361L17.0683 10.259L16.3325 8.7822L17.8093 9.51799L18.9865 8.36185L18.7431 9.99374L20.2064 10.756L18.5791 11.0288Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakistanFlag);
export default __webpack_public_path__ + "static/media/pakistan-flag.d8918f7c3b8c83d3230007791ad8e3c5.svg";
export { ForwardRef as ReactComponent };